/* assets/wbn-pdp.js - product-page behaviour that used to ship as parser-blocking
   inline <script> blocks in snippets/product-template.liquid, variant-button-pack.liquid
   (emitted twice per page), product-form.liquid (formerly wbn-pdp-sticky.js),
   Description_Multi_3.liquid, and the hydrasalt / new-product-template sections.
   Logic is verbatim unless a block says otherwise. Loaded once, defer, from
   sections/main-product.liquid. Every block is a no-op on pages that lack its markup. */
(function () {
  if (window.__wbnPdpInit) return;
  window.__wbnPdpInit = true;

  function ready(fn) {
    if (document.readyState === 'complete') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* 1. Variant-specific product title (snippets/product-template.liquid) */
  (function () {
    var dataEl = document.querySelector('script[id^="ProductSingleTitleMap-"]');
    if (!dataEl) return;
    var heading = document.getElementById('ProductSingleTitle-' + dataEl.id.slice('ProductSingleTitleMap-'.length));
    if (!heading) return;
    var map = {};
    try { map = JSON.parse(dataEl.textContent); } catch (e) {}
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      var t = map[v.id];
      if (t) heading.textContent = t;
    });
  })();

  /* 2. Variant selection sync + scroll lock (snippets/variant-button-pack.liquid) */
ready(function () {
  if (window.__wbnVariantScrollInit) return;
  window.__wbnVariantScrollInit = true;

  // ===== CONFIGURATION =====
  // Set to false to DISABLE scroll prevention on variant selection
  const PREVENT_VARIANT_SCROLL = true;
  // ========================
  
  // Function to sync variant selection visual state
  function syncVariantSelection() {
    const checkedInputs = document.querySelectorAll('.variant-input input[type="radio"]:checked');
    
    checkedInputs.forEach(checkedInput => {
      const variantValue = checkedInput.value;
      const variantName = checkedInput.name;
      
      // Find all variant buttons with the same value and name across the page
      const allVariantButtons = document.querySelectorAll(`.variant-input input[type="radio"][name="${variantName}"][value="${variantValue}"]`);
      
      allVariantButtons.forEach(input => {
        const buttonLabel = input.closest('.variant-input').querySelector('.variant__button-label');
        const flag = input.closest('.variant-card__container')?.querySelector('.variant-card__flag');
        
        if (buttonLabel) {
          buttonLabel.classList.add('selected');
        }
        
        if (flag) {
          flag.classList.add('selected');
        }
      });
    });
  }
  
  // Function to clear all variant selection visual states
  function clearVariantSelection() {
    const allButtonLabels = document.querySelectorAll('.variant-input .variant__button-label');
    const allFlags = document.querySelectorAll('.variant-card__flag');
    
    allButtonLabels.forEach(label => {
      label.classList.remove('selected');
    });
    
    allFlags.forEach(flag => {
      flag.classList.remove('selected');
    });
  }
  
  // Function to apply visual state to a specific variant
  function applyVariantSelection(variantInput) {
    clearVariantSelection();
    
    const variantValue = variantInput.value;
    const variantName = variantInput.name;
    
    // Find all variant buttons with the same value and name across the page
    const allVariantButtons = document.querySelectorAll(`.variant-input input[type="radio"][name="${variantName}"][value="${variantValue}"]`);
    
    allVariantButtons.forEach(input => {
      const buttonLabel = input.closest('.variant-input').querySelector('.variant__button-label');
      const flag = input.closest('.variant-card__container')?.querySelector('.variant-card__flag');
      
      if (buttonLabel) {
        buttonLabel.classList.add('selected');
      }
      
      if (flag) {
        flag.classList.add('selected');
      }
    });
  }
  
  // Scroll lock functions for both desktop and mobile (especially sticky bar)
  if (PREVENT_VARIANT_SCROLL) {
    const originalWindowScrollTo = window.scrollTo.bind(window);
    let variantScrollLock = false;
    let lockTimer = null;
    let lockedScrollPosition = {
      x: window.pageXOffset || document.documentElement.scrollLeft,
      y: window.pageYOffset || document.documentElement.scrollTop,
    };

    function lockVariantScroll(duration) {
      const lockDuration = typeof duration === 'number' ? duration : 250;
      variantScrollLock = true;
      lockedScrollPosition.x = window.pageXOffset || document.documentElement.scrollLeft;
      lockedScrollPosition.y = window.pageYOffset || document.documentElement.scrollTop;

      if (lockTimer) {
        clearTimeout(lockTimer);
      }

      lockTimer = setTimeout(function() {
        variantScrollLock = false;
        lockTimer = null;
      }, lockDuration);
    }

    function restoreScroll(y) {
      if (typeof y !== 'number') return;
      window.requestAnimationFrame(function() {
        originalWindowScrollTo(0, y);
      });
    }

    // Keep scroll position locked while flag is active
    window.addEventListener('scroll', function() {
      if (variantScrollLock) {
        originalWindowScrollTo(lockedScrollPosition.x, lockedScrollPosition.y);
      }
    }, { passive: true });

    function onVariantAction(target) {
      if (!target) return;
      const previousScrollY = window.pageYOffset || document.documentElement.scrollTop;
      lockVariantScroll(300);
      applyVariantSelection(target);

      // Restore immediately and once more after theme variant updates complete
      restoreScroll(previousScrollY);
      setTimeout(function() {
        restoreScroll(previousScrollY);
      }, 60);
    }

    // Capture phase ensures we lock before theme variant handlers run
    document.addEventListener('click', function(e) {
      const target = e.target.closest('.variant-input .variant__button-label, .variant-input input[type="radio"], .pdp-sticky-bar .variant-input .variant__button-label, .pdp-sticky-bar .variant-input input[type="radio"]');
      const input = target?.closest('.variant-input')?.querySelector('input[type="radio"]') || target;
      onVariantAction(input);
    }, true);

    document.addEventListener('change', function(e) {
      const target = e.target.closest('[data-variant-input], .variant-input input[type="radio"], [data-product-select]');
      onVariantAction(target);
    }, true);

    document.addEventListener('variant:change', function() {
      const selected = document.querySelector('.variant-input input[type="radio"]:checked');
      onVariantAction(selected);
    });
  }
  
  // Initial sync on page load
  syncVariantSelection();
  
  // Also sync when the sticky bar is initially created (for cases where it's already sticky)
  if (window.matchMedia('(max-width: 768px)').matches) {
    const stickyBar = document.querySelector('.pdp-sticky-bar');
    if (stickyBar && stickyBar.classList.contains('is-sticky')) {
      syncVariantSelection();
    }
  }
  
  // Sync when sticky bar becomes active (for mobile scroll behavior)
  if (window.matchMedia('(max-width: 768px)').matches) {
    // Create a MutationObserver to watch for sticky bar changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const stickyBar = mutation.target;
          if (stickyBar.classList.contains('is-sticky')) {
            // Small delay to ensure DOM is updated
            setTimeout(syncVariantSelection, 100);
          }
        }
      });
    });
    
    // Start observing the sticky bar
    const stickyBar = document.querySelector('.pdp-sticky-bar');
    if (stickyBar) {
      observer.observe(stickyBar, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    
    // Also listen for scroll events to catch sticky bar state changes
    let lastScrollY = window.scrollY;
    window.addEventListener('scroll', function() {
      const currentScrollY = window.scrollY;
      if (Math.abs(currentScrollY - lastScrollY) > 50) { // Only sync on significant scroll
        setTimeout(syncVariantSelection, 50);
        lastScrollY = currentScrollY;
      }
    }, { passive: true });
  }
});

  /* 3. Sticky add-to-cart bar (was assets/wbn-pdp-sticky.js) */
/* PDP sticky add-to-cart bar behaviour + notify-me variant sync.
   Moved verbatim (logic unchanged) out of snippets/product-form.liquid, where
   it shipped as ~14KB of parser-blocking inline <script> on every product
   page (and, on the hydrasalt template, twice). One deferred cached file; the
   only Liquid value it used (the initial variant id) now comes from the
   data-wbn-initial-variant attribute on #add-to-cart-btn-IL. */
(function () {
  if (window.__wbnPdpStickyInit) return;
  window.__wbnPdpStickyInit = true;

  /* 1. Mobile step-sticky (was the first inline block) */
  function initILStickyBar() {
    try {
      var pdpBar = document.querySelector('.pdp-sticky-bar');
      if (!pdpBar) return;
      var step1 = 1400, step2 = 1600, step3 = 1800;
      var currentStep = 0;
      var isStickyActive = false;

      function setBikChatBottom(pxValue) {
        var bikChatIframe = document.querySelector('iframe#bik-chat-iframe');
        if (bikChatIframe) bikChatIframe.style.setProperty('bottom', pxValue, 'important');
      }

      function updateState() {
        var y = window.scrollY;
        var isMobileViewport = window.matchMedia('(max-width: 768px)').matches;
        if (!isMobileViewport) {
          pdpBar.classList.remove('is-sticky1');
          pdpBar.classList.remove('is-sticky-dk');
          var mobileStickyDesktop = document.querySelector('.mobile-variant-sticky');
          if (mobileStickyDesktop) mobileStickyDesktop.classList.remove('is-visible');
          return;
        }
        var newStep = 0;
        if (y >= step3) newStep = 3;
        else if (y >= step2) newStep = 2;
        else if (y >= step1) newStep = 1;
        if (newStep !== currentStep) currentStep = newStep;

        var e2 = document.querySelector('.mobile-variant-sticky');
        var el = document.querySelector('.variant-picker');
        if (currentStep >= 1 && !isStickyActive) {
          pdpBar.classList.add('is-sticky1');
          setBikChatBottom('150px');
          if (el) el.style.display = 'none';
          if (e2) e2.classList.add('is-visible');
          isStickyActive = true;
        }
        if (currentStep === 0 && isStickyActive) {
          pdpBar.classList.remove('is-sticky1');
          setBikChatBottom('69px');
          if (el) el.style.display = '';
          if (e2) e2.classList.remove('is-visible');
          isStickyActive = false;
        }
      }

      updateState();
      window.addEventListener('scroll', updateState, { passive: true });
    } catch (err) {
      console.warn('Step sticky failed:', err);
    }
  }

  /* 2. Desktop (>=789px) sticky with hysteresis */
  function initDesktopSticky789() {
    if (window.__wbnDesktopSticky789Init) return;
    window.__wbnDesktopSticky789Init = true;
    var pdpBar = document.querySelector('.pdp-sticky-bar');
    if (!pdpBar) return;
    var mql = window.matchMedia('(min-width: 789px)');
    var onPoint = 1450, offPoint = 1300;
    var isActive = false, ticking = false;

    function syncDesktopSticky789() {
      if (!mql.matches) {
        pdpBar.classList.remove('is-sticky-desktop-force');
        isActive = false;
        return;
      }
      var y = window.scrollY || window.pageYOffset || 0;
      var shouldEnable = isActive ? y >= offPoint : y >= onPoint;
      if (shouldEnable !== isActive) {
        isActive = shouldEnable;
        pdpBar.classList.toggle('is-sticky-desktop-force', isActive);
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { syncDesktopSticky789(); ticking = false; });
    }
    syncDesktopSticky789();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', syncDesktopSticky789);
  }

  /* 3. Keep scroll position when a variant is picked inside the sticky bar */
  function initStickyVariantPreserve() {
    if (window.__wbnStickyVariantPreserveInit) return;
    window.__wbnStickyVariantPreserveInit = true;
    var stickyBar = document.querySelector('.pdp-sticky-bar');
    if (!stickyBar) return;
    function preserveScrollPosition() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      window.requestAnimationFrame(function () { window.scrollTo(0, y); });
      setTimeout(function () { window.scrollTo(0, y); }, 60);
    }
    document.addEventListener('click', function (e) {
      var target = e.target.closest('.pdp-sticky-bar .variant-input .variant__button-label, .pdp-sticky-bar .variant-input input[type="radio"]');
      if (target) preserveScrollPosition();
    }, true);
    document.addEventListener('change', function (e) {
      var target = e.target.closest('.pdp-sticky-bar [data-variant-input], .pdp-sticky-bar .variant-input input[type="radio"], .pdp-sticky-bar [data-product-select]');
      if (target) preserveScrollPosition();
    }, true);
  }

  /* 4. Notify-me button follows the selected variant */
  function initNotifyMeSync() {
    var variantSelectors = document.querySelectorAll('[data-product-select], .variant-input, .swatch-element input');
    var atc = document.getElementById('add-to-cart-btn-IL');
    var initialVariant = atc ? atc.getAttribute('data-wbn-initial-variant') || '' : '';
    function updateNotifyMeButton() {
      var sel = document.querySelector('[data-product-select]');
      var checked = document.querySelector('.variant-input:checked');
      var currentVariantId = (sel && sel.value) || (checked && checked.value) || initialVariant;
      var notifyMeBtn = document.querySelector('.notifyMe_btn');
      if (!notifyMeBtn) return;
      notifyMeBtn.setAttribute('data-variant-id', currentVariantId);
      try {
        var productData = JSON.parse(notifyMeBtn.getAttribute('data-product'));
        if (productData) {
          productData.variant_id = parseInt(currentVariantId, 10);
          notifyMeBtn.setAttribute('data-product', JSON.stringify(productData));
        }
      } catch (e) {}
    }
    variantSelectors.forEach(function (selector) { selector.addEventListener('change', updateNotifyMeButton); });
  }

  /* 5. Mobile variant-inline sticky activator using scrollYOrigin */
  function initMobileVariantSticky() {
    try {
      var pdpBar = document.querySelector('.pdp-sticky-bar');
      if (!pdpBar) return;
      var isMobile = window.matchMedia('(max-width: 768px)').matches;
      if (!isMobile) return; // desktop handled by initDesktopSticky789
      var inlineContainer = document.querySelector('.mobile-variant-inline')
        || document.querySelector('.product-block.product-block--price')
        || pdpBar;
      var scrollYOrigin = 0, hysteresis = 12, isStickyActive = false;
      function computeOrigin() {
        var rect = inlineContainer.getBoundingClientRect();
        scrollYOrigin = window.scrollY + rect.top + inlineContainer.offsetHeight;
      }
      function activateSticky() { if (isStickyActive) return; pdpBar.classList.add('is-sticky'); isStickyActive = true; }
      function deactivateSticky() { if (!isStickyActive) return; pdpBar.classList.remove('is-sticky'); isStickyActive = false; }
      function evaluate() {
        if (window.scrollY >= scrollYOrigin + hysteresis) activateSticky();
        else if (window.scrollY <= scrollYOrigin - hysteresis) deactivateSticky();
      }
      computeOrigin();
      evaluate();
      window.addEventListener('resize', computeOrigin);
      window.addEventListener('orientationchange', computeOrigin);
      window.addEventListener('scroll', evaluate, { passive: true });
    } catch (e) {
      console.warn('Sticky feature failed', e);
    }
  }

  function onReady() {
    initILStickyBar();
    initDesktopSticky789();
    initStickyVariantPreserve();
    initNotifyMeSync();
    initMobileVariantSticky();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();

  /* 4. Stock counter (snippets/product-template.liquid); returns unless [data-stock-container] exists */
  (function() {
    try {
      var container = document.querySelector('[data-stock-container]');
      if (!container) return;
      var stockTextEl = container.querySelector('.stock-count__text');
      if (!stockTextEl) return;
      var variants = window.productVariants || [];
      function getVariantById(id) {
        id = typeof id === 'string' ? parseInt(id, 10) : id;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i] && variants[i].id === id) return variants[i];
        }
        return null;
      }
      function storageKey(variantId) {
        // v2 to avoid conflicts with any previously stored <20 values
        return 'variantStockDisplayV2-' + variantId;
      }
      function countKey(variantId) {
        return 'variantStockDisplayV2Count-' + variantId;
      }
      function getRandomBetween(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }
      // Generate and persist the next value for a variant (only called on page load)
      function generateNextForVariant(variant) {
        if (!variant) return;
        var qty = (typeof variant.inventory_quantity === 'number') ? variant.inventory_quantity : null;
        var key = storageKey(variant.id);
        var cKey = countKey(variant.id);
        // Do not persist anything for tracked < 20; ensure any stale value is cleared
        if (typeof qty === 'number' && qty < 20) {
          try { sessionStorage.removeItem(key); } catch (e) {}
          try { sessionStorage.removeItem(cKey); } catch (e) {}
          return;
        }
        var minVal = 20;
        var maxVal = 50;
        var previous = parseInt(sessionStorage.getItem(key), 10);
        var stepCount = parseInt(sessionStorage.getItem(cKey), 10);
        stepCount = isNaN(stepCount) ? 0 : stepCount;
        var nextVal = previous;
        // If we've already completed three generations, keep the previous value
        if (stepCount >= 3 && !isNaN(previous) && previous >= minVal && previous <= maxVal) {
          nextVal = previous;
        } else if (isNaN(previous) || previous < minVal || previous > maxVal) {
          // First time or invalid legacy value: seed between 21 and 50 to avoid initial 20
          nextVal = getRandomBetween(minVal + 1, maxVal);
          stepCount = 1;
        } else if (previous > minVal) {
          var newMax = Math.max(minVal, previous - 1);
          if (newMax <= minVal) {
            nextVal = minVal;
            stepCount = Math.max(stepCount + 1, 3);
          } else {
            nextVal = getRandomBetween(minVal, newMax);
            stepCount = stepCount + 1;
          }
        } else {
          nextVal = minVal;
          // If we reached min, consider the sequence complete
          stepCount = Math.max(stepCount, 3);
        }
        try { sessionStorage.setItem(key, String(nextVal)); } catch (e) {}
        try { sessionStorage.setItem(cKey, String(stepCount)); } catch (e) {}
      }
      function seedAllVariants() {
        if (!Array.isArray(variants)) return;
        for (var i = 0; i < variants.length; i++) {
          generateNextForVariant(variants[i]);
        }
      }
      function computeDisplayQty(variant) {
        var qty = (variant && typeof variant.inventory_quantity === 'number') ? variant.inventory_quantity : null;
        // If tracked and below 20, show actual quantity and do not read/write storage
        if (typeof qty === 'number' && qty < 20) {
          return qty;
        }
        // For >= 20 or untracked, read the pre-seeded session value only (no generation here)
        var key = storageKey(variant.id);
        var stored = parseInt(sessionStorage.getItem(key), 10);
        return isNaN(stored) ? 20 : stored;
      }
      function updateStockText(variant) {
        if (!variant) return;
        var displayQty = computeDisplayQty(variant);
        stockTextEl.textContent = 'Only ' + displayQty + ' left in stock';
        container.setAttribute('data-variant-id', variant.id);
      }
      // Seed values for all variants on page load so variant changes do not generate new numbers
      seedAllVariants();
      // Initialize with current variant id from DOM attribute
      var initialIdAttr = container.getAttribute('data-variant-id');
      var initialVariant = null;
      if (initialIdAttr) {
        initialVariant = getVariantById(parseInt(initialIdAttr, 10));
      }
      if (!initialVariant && Array.isArray(variants) && variants.length) {
        // Fallback: find selected_or_first_available_variant by availability
        initialVariant = variants.find(function(v){ return v && v.available; }) || variants[0];
      }
      if (initialVariant) {
        updateStockText(initialVariant);
      }
      // Listen for theme variant change events
      document.addEventListener('variant:change', function(e) {
        try {
          var v = e && e.detail && e.detail.variant ? e.detail.variant : null;
          if (v) {
            updateStockText(v);
          }
        } catch (err) {
          // no-op
        }
      });
    } catch (e) {
      // no-op
    }
  })();

  /* 5. Lab-report download (snippets/Description_Multi_3.liquid, sections/product-lab-report.liquid) */
  window.downloadFile = function downloadFile(url, filename) {
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.blob();
      })
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename || 'lab-report.pdf';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch(error => {
        console.error('Download failed:', error);
        window.open(url, '_blank');
      });
  };

  /* 6. Below-fold autoplay videos: <video preload="none" data-wbn-src> gets its src and
        plays when within 200px of the viewport, pauses when it leaves (hydrasalt sections).
        Videos inside display:none flavour blocks/modals never intersect, so they only load
        once their flavour is shown. */
  (function () {
    var vids = document.querySelectorAll('video[data-wbn-src]');
    if (!vids.length) return;
    function play(v) {
      if (!v.getAttribute('src')) v.src = v.getAttribute('data-wbn-src');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play(e.target);
        else if (e.target.getAttribute('src')) e.target.pause();
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  })();

  /* 7. Tabs (sections/Whats_multi_section.liquid) */
ready(function () {
    // Handle tab functionality for each common-grid
    document.querySelectorAll('.common-grid').forEach(grid => {
        const tabs = grid.querySelectorAll('.tab-block');
        const contents = grid.querySelectorAll('.tab-content');

        // Initialize first tab as active
        if (tabs.length > 0 && contents.length > 0) {
            tabs[0].classList.add('active');
            const firstTabId = tabs[0].getAttribute('data-tab-id');
            const firstContent = grid.querySelector(`#${firstTabId}`);
            if (firstContent) {
                firstContent.classList.add('active');
            }
        }

        // Handle tab clicks
        tabs.forEach(tab => {
            tab.addEventListener('click', function () {
                // Remove active class from all tabs and contents in this grid
                tabs.forEach(t => t.classList.remove('active'));
                contents.forEach(c => c.classList.remove('active'));

                // Add active class to clicked tab and corresponding content
                tab.classList.add('active');
                const tabId = tab.getAttribute('data-tab-id');
                const content = grid.querySelector(`#${tabId}`);
                if (content) {
                    content.classList.add('active');
                }
            });
        });
    });
});

  /* 8. Mobile slide stack (sections/Stick_section.liquid) */
  ready(function () {
    if (!window.Swiper || !window.jQuery || !document.querySelector('.fiexts-block')) return;
    if ($(window).width() < 768) {
    const swiperflexi = new Swiper('.fiexts-block', {
      wrapperClass: 'fwraper',
      slideClass: 'stik-slide',
      autoHeight: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      on: {
        slideChangeTransitionStart() {
          swiperflexi.updateAutoHeight(300);
        }
      }
    });
    }
  });

  /* 9. Ingredient slider (sections/Ingredient-wrapper.liquid) */
  ready(function () {
    if (!window.Swiper || !window.jQuery || !document.querySelector('.ingredient-swiper')) return;
			const ingredien_swiper = new Swiper('.ingredient-swiper', {
				slidesPerView: "auto", spaceBetween: 0, loop: false
			});

			$('.ingredient-title').on('click', function(){
				var id = $(this).data('id')
				ingredien_swiper.slideTo(id-1)
				$('.ingredient-title').removeClass('is-active')
				$(this).addClass('is-active')
			})

			ingredien_swiper.on('slideChange', () => {
				$('.ingredient-title').removeClass('is-active')
				$('.ingredient-title.is-'+(ingredien_swiper.activeIndex+1)).addClass('is-active')
			});
  });

  /* 10. FAQ accordion (sections/Faq_sectio.liquid) */
  ready(function () {
    if (!window.jQuery) return;
        $(".faq-block.is-title").click(function () {
            $(".open").not(this).removeClass("open").next().slideUp(300).parent().removeClass("active");
            $(this).toggleClass("open").next().slideToggle(300).parent().toggleClass("active");
        });
  });

  /* 11. Lazy banner video (sections/product-banner-with-video.liquid) */
  (function () {
    if (window.__wbnBannerVideo) return;
    window.__wbnBannerVideo = true;

    // Two shapes to restore, because this section has two rendering paths:
    //   1. video[data-wbn-video-src]  -- the explicit video_src branch
    //   2. source[data-wbn-src]       -- Shopify's metafield_tag branch, the one that
    //                                    actually renders on live products
    //
    // The `autoplay` attribute was removed from both, so nothing is fetched at parse
    // time and playback is driven from here instead. The elements keep the poster that
    // metafield_tag supplies, so the banner looks identical before the file arrives.
    //
    // Activation is on scroll approach, not page load: a visitor who never reaches this
    // section downloads none of the video (7.48 MB on the product measured .
    // One who does reach it still gets a video that starts by itself, because it is
    // muted -- muted playback is exempt from autoplay blocking, so play() resolves.
    function matches(v) {
      var mq = v.getAttribute('data-wbn-video-mq');
      if (!mq) return true;
      if (!window.matchMedia) return true; // no matchMedia: load rather than show nothing
      return window.matchMedia(mq).matches;
    }

    function isPending(v) {
      return v.hasAttribute('data-wbn-video-src') || !!v.querySelector('source[data-wbn-src]');
    }

    function attach(v) {
      if (!matches(v) || !isPending(v)) return;

      var direct = v.getAttribute('data-wbn-video-src');
      if (direct) {
        v.removeAttribute('data-wbn-video-src'); // one-shot, so nothing can refetch
        v.src = direct;
      }
      Array.prototype.forEach.call(v.querySelectorAll('source[data-wbn-src]'), function (s) {
        s.setAttribute('src', s.getAttribute('data-wbn-src'));
        s.removeAttribute('data-wbn-src');
      });

      v.load(); // required: sources added after parse need an explicit reload
      var p = v.play();
      if (p && p.catch) p.catch(function () {}); // e.g. reduced-data mode; poster remains
    }

    function pending() {
      return Array.prototype.filter.call(
        document.querySelectorAll('video[data-wbn-video-mq], video[data-wbn-video-src]'),
        isPending
      );
    }

    function observe() {
      var vids = pending();
      if (!vids.length) return;

      if (!('IntersectionObserver' in window)) {
        vids.forEach(attach);
        return;
      }

      // rootMargin buys the metadata round-trip before the section is on screen, so the
      // video's intrinsic size settles off-viewport and cannot shift visible content.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          attach(e.target);
        });
      }, { rootMargin: '400px 0px' });

      vids.forEach(function (v) { io.observe(v); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observe);
    } else {
      observe();
    }

    // Crossing the breakpoint (rotation, desktop resize) reveals the other block, whose
    // source is still pending. Debounced; each video is only ever attached once.
    var t = null;
    window.addEventListener('resize', function () {
      if (t) clearTimeout(t);
      t = setTimeout(observe, 200);
    }, { passive: true });
  })();

  /* 12. Variant-specific "Additional Information" (sections/additional-info.liquid).
        The JSON map now carries one "default" entry plus per-variant overrides only. */
  (function () {
    var dataEl = document.querySelector('script[id^="AdditionalInfoMap-"]');
    if (!dataEl) return;
    var pid = dataEl.id.slice('AdditionalInfoMap-'.length);
    var rte = document.getElementById('AdditionalInfoRte-' + pid);
    var wrap = document.querySelector('[data-additional-info-wrap="' + pid + '"]');
    if (!rte || !wrap) return;
    var map = {};
    try { map = JSON.parse(dataEl.textContent); } catch (e) {}
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      var html = map[v.id] != null ? map[v.id] : map['default'];
      if (html && html.replace(/\s|&nbsp;/g, '').length) {
        rte.innerHTML = html;
        wrap.style.display = '';
      } else {
        wrap.style.display = 'none';
      }
    });
  })();
})();
